// import { AuthProvider } from '@redwoodjs/auth'
import EthereumAuthClient from '@oneclickdapp/ethereum-auth'
import { ApolloClient, InMemoryCache } from '@apollo/client'
import { FetchConfigProvider, useFetchConfig } from '@redwoodjs/web'
import ReactDOM from 'react-dom'
import DefaultLayout from 'src/layouts/DefaultLayout'
import { FatalErrorBoundary } from '@redwoodjs/web'
import { RedwoodApolloProvider } from '@redwoodjs/web/apollo'
import { AuthProvider } from '@redwoodjs/auth'

import { Toaster } from 'react-hot-toast'

import FatalErrorPage from 'src/pages/FatalErrorPage'
import Routes from 'src/Routes'

import './scaffold.css'
import './index.css'

let ethereum

const ApolloInjector = ({ children }) => {
  const { uri, headers } = useFetchConfig()
  let ethereum
  try {
    const graphQLClient = new ApolloClient({
      cache: new InMemoryCache(),
      uri,
      headers,
    })

    const makeRequest = (mutation, variables) =>
      graphQLClient.mutate({
        mutation,
        variables,
      })

    ethereum = new EthereumAuthClient({
      makeRequest,
      // Note: you must set NODE_ENV manually when using Netlify
      debug: process.NODE_ENV !== 'production',
    })
  } catch (e) {
    console.log(e)
  }
  return React.cloneElement(children, { client: ethereum })
}

ReactDOM.render(
  <FatalErrorBoundary page={FatalErrorPage}>
    <Toaster position="top-left" reverseOrder={true} />
    <FetchConfigProvider>
      <ApolloInjector>
        <AuthProvider client={ethereum} type="ethereum">
          <RedwoodApolloProvider>
            <DefaultLayout>
              <Routes />
            </DefaultLayout>
          </RedwoodApolloProvider>
        </AuthProvider>
      </ApolloInjector>
    </FetchConfigProvider>
  </FatalErrorBoundary>,
  document.getElementById('redwood-app')
)
